import {callAPI} from '@/store/utils'; // eslint-disable-line

const FYGR_COMPANY = 'FYGR_COMPANY';

export default {
  namespaced: true,
  state: {
    savedVATs: [],
  },
  mutations: {
    seVats(state, data) {
      state.savedVATs = data
        .map((el) => ({
          id: el,
          rate: el,
          alterable: !!el,
        }))
        .sort((a, b) => {
          if (a.rate > b.rate) {
            return 1;
          }
          if (a.rate < b.rate) {
            return -1;
          }
          return 0;
        });
    },
  },
  actions: {
    async actionGetVAT({commit}) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('GET', `company/${companyId}/vat`);
      commit('seVats', res?.result);
      return res;
    },
    async actionSetVAT({commit, dispatch}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('PATCH', `company/${companyId}/vat`, {
        ...params,
        companyId,
      });
      commit('app/setCategoriesWithSubcategories', res?.result?.categories, {
        root: true,
      });
      if (res.error) {
        dispatch(
          'app/actionAddNotification',
          {
            msg: 'Erreur interne du serveur',
            color: 'red',
            disappearing: true,
          },
          {root: true},
        );
      } else {
        dispatch(
          'app/actionAddNotification',
          {
            msg: 'Catégorie mise à jour',
            color: 'green',
            disappearing: true,
          },
          {root: true},
        );
      }
      return res;
    },
    async actionAddVAT({dispatch}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('PUT', `company/${companyId}/vat`, {
        ...params,
        companyId,
      });
      if (res.error) {
        dispatch(
          'app/actionAddNotification',
          {
            msg: 'Erreur interne du serveur',
            color: 'red',
            disappearing: true,
          },
          {root: true},
        );
      } else {
        dispatch(
          'app/actionAddNotification',
          {
            msg: 'TVA ajoutée',
            color: 'green',
            disappearing: true,
          },
          {root: true},
        );
      }
      return res;
    },
    async actionRemoveVAT({commit, dispatch}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('DELETE', `company/${companyId}/vat`, {
        ...params,
        companyId,
      });
      if (res.error) {
        dispatch(
          'app/actionAddNotification',
          {
            msg: 'Erreur interne du serveur',
            color: 'red',
            disappearing: true,
          },
          {root: true},
        );
      } else {
        commit('app/setCategoriesWithSubcategories', res.result.categories, {
          root: true,
        });
        dispatch(
          'app/actionAddNotification',
          {
            msg: 'Le taux de TVA a été supprimé',
            color: 'green',
            disappearing: true,
          },
          {root: true},
        );
      }
      return res;
    },
  },
};
